export default function init(element) {
    let scrollPos = 0;
    window.addEventListener('scroll', fixedHeader);

    function fixedHeader() {
        if ((document.body.getBoundingClientRect()).top > scrollPos) {
            element.classList.remove('!-top-28');
        } else {
            element.classList.add('!-top-28');
        }
        scrollPos = (document.body.getBoundingClientRect()).top;
    }
}

